<modal-header [title]="'Task Location Import Failed'" (onClose)="onDialogClose()"></modal-header>

<div class="modal-body" style="max-height: 60vh; overflow: scroll">
  <ul>
    <li *ngFor="let error of errorList">
      <span class="text-warning">{{ error }}</span>
    </li>
  </ul>
</div>
